import { render, staticRenderFns } from "./popup-item.vue?vue&type=template&id=3b34201a&scoped=true&"
import script from "./popup-item.vue?vue&type=script&lang=js&"
export * from "./popup-item.vue?vue&type=script&lang=js&"
import style0 from "./popup-item.vue?vue&type=style&index=0&id=3b34201a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34201a",
  null
  
)

export default component.exports